export default {
  'recurring.daily': 'Daily',
  'recurring.end': 'End Date',
  'recurring.frequency': 'Frequency',
  'recurring.dateError': 'Unable to set recurring transfer for today',
  'recurring.monthly': 'Monthly',
  'recurring.noEndDate': 'No end date',
  'recurring.repeat': 'Repeat every',
  'recurring.recurrenceAsText': 'Recurring Transfer:',
  'recurring.select': 'Select',
  'recurring.selectADate': 'Select a Date',
  'recurring.semimonthly': 'Semi-Monthly',
  'recurring.start': 'Start Date',
  'recurring.title': 'Recurring Transfer',
  'recurring.weekly': 'Weekly'
};
